/* Jane Lushka v1.2: product gallery and page grid (phase 3, pdp:1 and M1).
   1) Fancybox: one delegated binding for every [data-fancybox="product-media"] photo (L2). ext-fancybox.js is
      loaded (defer) right before this file, so it is normally there; if it is missing at click time the tile
      link simply opens the 2400px image.
   2) Sticky info column: a ResizeObserver on the header section and on each .jl-pdp__info sets
      --jl-header-h and --jl-info-top = min(header + 24px, innerHeight - info height - 24px) on .jl-pdp, so a
      box taller than the viewport scrolls until its bottom shows and then sticks.
   3) Phone swipe gallery: the counter ("2 / 4") and the decorative dots follow the track's scroll position;
      prev / next move it.
   Every handler is delegated or re-scanned on shopify:section:load, so a re-rendered section works again. */
(function () {
  'use strict';

  if (window.__jlPdpGalleryLoaded) return;
  window.__jlPdpGalleryLoaded = true;

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* ---------- 1) Fancybox ---------- */
  function bindFancybox() {
    if (window.__jlFancyBound) return true;
    var F = window.Fancybox;
    if (!F || typeof F.bind !== 'function') return false;
    F.bind('[data-fancybox="product-media"]', { animated: false, showClass: false, Hash: false });
    window.__jlFancyBound = true;
    return true;
  }

  /* ---------- 2) header height and the sticky info column ---------- */
  var resizeObserver = null;
  var observed = typeof WeakSet === 'function' ? new WeakSet() : null;
  var measureQueued = false;

  function headerEl() {
    return document.getElementById('shopify-section-header') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.querySelector('header');
  }

  function headerHeight() {
    var h = headerEl();
    if (!h) return 0;
    var pos = window.getComputedStyle(h).position;
    if (pos !== 'sticky' && pos !== '-webkit-sticky' && pos !== 'fixed') return 0;
    return Math.round(h.getBoundingClientRect().height);
  }

  function measure() {
    measureQueued = false;
    var header = headerHeight();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var pages = document.querySelectorAll('[data-jl-pdp]');
    for (var i = 0; i < pages.length; i++) {
      var pdp = pages[i];
      var info = pdp.querySelector('.jl-pdp__info');
      var top = header + 24;
      if (info) {
        var ih = info.offsetHeight;
        top = Math.min(header + 24, vh - ih - 24);
      }
      pdp.style.setProperty('--jl-header-h', header + 'px');
      pdp.style.setProperty('--jl-info-top', Math.round(top) + 'px');
    }
  }

  function queueMeasure() {
    if (measureQueued) return;
    measureQueued = true;
    window.requestAnimationFrame(measure);
  }

  function observe(el) {
    if (!el || !resizeObserver) return;
    if (observed) {
      if (observed.has(el)) return;
      observed.add(el);
    }
    resizeObserver.observe(el);
  }

  /* ---------- 3) phone swipe gallery ---------- */
  function slidesOf(gallery) {
    return gallery.querySelectorAll('[data-jl-gallery-slide]');
  }

  function currentIndex(track) {
    var w = track.clientWidth || 1;
    return Math.round(track.scrollLeft / w);
  }

  function updateUi(gallery) {
    var track = gallery.querySelector('[data-jl-gallery-track]');
    if (!track) return;
    var total = slidesOf(gallery).length;
    if (!total) return;
    var idx = Math.max(0, Math.min(total - 1, currentIndex(track)));
    if (gallery.__jlIndex === idx) return;
    gallery.__jlIndex = idx;
    var cur = gallery.querySelector('[data-jl-gallery-current]');
    if (cur) cur.textContent = String(idx + 1);
    // the dots are decorative (aria-hidden): only their look follows the slide
    var dots = gallery.querySelectorAll('[data-jl-gallery-dot]');
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-current', i === idx);
  }

  function goTo(gallery, idx) {
    var track = gallery.querySelector('[data-jl-gallery-track]');
    if (!track) return;
    var total = slidesOf(gallery).length;
    if (!total) return;
    if (idx < 0) idx = total - 1;
    if (idx > total - 1) idx = 0;
    var left = idx * track.clientWidth;
    var behavior = reduceMotion.matches ? 'auto' : 'smooth';
    if (typeof track.scrollTo === 'function') {
      try { track.scrollTo({ left: left, behavior: behavior }); } catch (e) { track.scrollLeft = left; }
    } else {
      track.scrollLeft = left;
    }
    // reduced motion (instant) updates at once; a smooth scroll updates from the scroll events
    if (behavior === 'auto') updateUi(gallery);
  }

  var scrollQueue = [];
  var scrollQueued = false;

  function flushScroll() {
    scrollQueued = false;
    var list = scrollQueue;
    scrollQueue = [];
    for (var i = 0; i < list.length; i++) updateUi(list[i]);
  }

  // scroll does not bubble; listen in the capture phase for every gallery track at once
  document.addEventListener('scroll', function (event) {
    var t = event.target;
    if (!t || t.nodeType !== 1 || !t.hasAttribute('data-jl-gallery-track')) return;
    var gallery = t.closest('[data-jl-gallery]');
    if (!gallery) return;
    if (scrollQueue.indexOf(gallery) < 0) scrollQueue.push(gallery);
    if (!scrollQueued) {
      scrollQueued = true;
      window.requestAnimationFrame(flushScroll);
    }
  }, { capture: true, passive: true });

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-jl-gallery-prev], [data-jl-gallery-next]');
    if (!btn) return;
    var gallery = btn.closest('[data-jl-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-jl-gallery-track]');
    if (!track) return;
    var idx = currentIndex(track);
    if (btn.hasAttribute('data-jl-gallery-prev')) goTo(gallery, idx - 1);
    else goTo(gallery, idx + 1);
  });

  /* ---------- init (again after a section re-render) ---------- */
  function init() {
    bindFancybox();
    if (!resizeObserver && typeof window.ResizeObserver === 'function') {
      resizeObserver = new ResizeObserver(queueMeasure);
    }
    observe(headerEl());
    var infos = document.querySelectorAll('[data-jl-pdp] .jl-pdp__info');
    for (var i = 0; i < infos.length; i++) observe(infos[i]);
    var galleries = document.querySelectorAll('[data-jl-gallery]');
    for (var j = 0; j < galleries.length; j++) {
      galleries[j].__jlIndex = -1;
      updateUi(galleries[j]);
    }
    measure();
  }

  window.addEventListener('resize', queueMeasure, { passive: true });
  window.addEventListener('load', function () {
    bindFancybox();
    queueMeasure();
  });
  window.addEventListener('pageshow', queueMeasure);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
